import { Observable, of } from 'rxjs';

import { LogWriter } from './log-writer';
import { LogEntry } from '../models/log-entry';

export class ConsoleWriter implements LogWriter {
    public location = null;

    public clear(): Observable<boolean> {
        // eslint-disable-next-line
        console.clear();
        return of(true);
    }

    public log(entry: LogEntry): Observable<boolean> {
        if (entry) {
            // eslint-disable-next-line
            console.log(entry.toString());
        }
        return of(true);
    }
}
